import React, { useState } from "react";
import { Link } from "react-router-dom";
import { AuthShell } from "@/components/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api, { formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { CheckCircle2 } from "lucide-react";

export default function ForgotPasswordPage() {
  const { t } = useI18n();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("auth.forgotTitle")} subtitle={t("auth.forgotSubtitle")}>
      {sent ? (
        <div data-testid="forgot-sent" className="rounded-md border border-green-500/30 bg-green-500/10 px-4 py-4 text-sm text-green-200 flex items-start gap-3">
          <CheckCircle2 className="w-5 h-5 shrink-0 mt-0.5" />
          <span>{t("auth.forgotSent")}</span>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <div className="space-y-2">
            <Label className="text-white/80">{t("auth.email")}</Label>
            <Input
              data-testid="forgot-email"
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder={t("auth.emailPh")}
              className="bg-[#0a0a0a] border-white/15 text-white h-11 placeholder:text-white/30"
            />
          </div>
          {error && (
            <div data-testid="forgot-error" className="rounded-md border border-[#dc143c]/40 bg-[#dc143c]/10 px-4 py-2.5 text-sm text-red-300">{error}</div>
          )}
          <Button
            data-testid="forgot-submit"
            type="submit" disabled={loading}
            className="w-full h-11 bg-[#EAB308] text-black font-semibold rounded-md hover:opacity-90 transition-opacity"
          >
            {loading ? t("auth.forgotSubmitting") : t("auth.forgotSubmit")}
          </Button>
        </form>
      )}
      <div className="mt-6 text-center">
        <Link to="/login" className="text-sm text-white/50 hover:text-[#EAB308] transition-colors" data-testid="back-to-login">
          {t("auth.backToLogin")}
        </Link>
      </div>
    </AuthShell>
  );
}
